// The membership operators the backend accepts on a select filter. A select
// descriptor opts in through `operators`, because the backend rejects any
// operator but `in` on a key it does not declare as a membership filter.

export const OPERATIONS = [
  { symbol: "∈", text: "Is any of", value: "in" },
  { symbol: "∉", text: "Is none of", value: "not_in" },
  { symbol: "∃", text: "Has any value", value: "is_set" },
  { symbol: "∄", text: "Has no value", value: "is_not_set" },
];

export const NEGATABLE_OPERATORS = ["in", "not_in"];

// Only for a column that can be empty: on a NOT NULL column "has no value"
// matches nothing and "has any value" matches everything.
export const NULLABLE_OPERATORS = [
  ...NEGATABLE_OPERATORS,
  "is_set",
  "is_not_set",
];

export const isPresenceOp = op => op === "is_set" || op === "is_not_set";

// A single select holds its positive operator as `is`, which predates the
// envelope; on the wire it is the same set membership as a multi select's `in`.
export const toWireOp = op => (op === "is" || op == null ? "in" : op);
